var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSirenErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "71px",
    viewBox: "0 0 70 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "99931F11-BF67-4A4C-8483-7BC01A95C14B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.1_Library_12.1",
    transform: "translate(-685.000000, -230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Model",
    transform: "translate(430.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "siren",
    transform: "translate(255.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3922195,58.0832774 L34.6577992,58.0832774 L31.3169517,37.5832971 L34.6577992,16.3999842 L40.6427764,16.3999842 C42.7975874,16.3999842 44.9099323,17.1420835 46.5880274,18.4909822 C48.2661224,19.8398809 49.4442136,21.7395457 49.9031212,23.8401104 L57.3922195,58.0832774 Z",
    id: "Path",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6577992,16.3999842 L34.6577992,58.0832774 L11.9233788,58.0832774 L18.7549379,24.0013769 C19.6385063,19.5966145 23.5481252,16.3999842 28.0495295,16.3999842 L34.6577992,16.3999842 Z",
    id: "Path",
    fill: "#FF936A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6577992,34.1666338 L35.3894486,32.2548056 L34.6577992,30.0666377 C29.3700875,30.0666377 25.0686848,34.3579669 25.0686848,39.6332952 C25.0686848,44.2047908 28.3002163,48.0355538 32.602989,48.9758195 L32.602989,56.7166121 L34.6577992,56.7166121 L35.3894486,49.8261587 L34.6577992,45.0999566 C31.6358583,45.0999566 29.1783052,42.6481589 29.1783052,39.6332952 C29.1783052,36.6184314 31.6358583,34.1666338 34.6577992,34.1666338 Z",
    id: "Path",
    fill: "#C40048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2469136,39.6332952 C44.2469136,44.2047908 41.015382,48.0355538 36.7126094,48.9758195 L36.7126094,56.7166121 L34.6577992,56.7166121 L34.6577992,45.0999566 C37.6797401,45.0999566 40.1372931,42.6481589 40.1372931,39.6332952 C40.1372931,36.6184314 37.6797401,34.1666338 34.6577992,34.1666338 L34.6577992,32.2006857 L34.6577992,30.0666377 C39.9455108,30.0666377 44.2469136,34.3579669 44.2469136,39.6332952 Z",
    id: "Path",
    fill: "#910035"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#910035",
    points: "36.7126094 0 36.7126094 12.2999882 34.6577992 12.2999882 33.6303941 6.14999408 34.6577992 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C40048",
    points: "32.602989 0 34.6577992 0 34.6577992 12.2999882 32.602989 12.2999882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#910035",
    transform: "translate(62.883685, 26.666743) rotate(-11.298700) translate(-62.883685, -26.666743) ",
    points: "56.7164897 24.612989 69.0490312 24.6185384 69.050881 28.7204966 56.7183396 28.7149471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#910035",
    transform: "translate(55.448095, 10.689444) rotate(-45.000000) translate(-55.448095, -10.689444) ",
    points: "49.2894068 8.6301327 61.6019719 8.64456713 61.6067834 12.7487555 49.2942183 12.7343211"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 4.783329)",
    fill: "#C40048"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(6.466186, 21.860756) rotate(-78.701300) translate(-6.466186, -21.860756) ",
    points: "4.4123634 15.6935601 8.51445831 15.69541 8.52000778 28.0279514 4.41791287 28.0261015"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(13.857808, 5.901574) rotate(-45.000000) translate(-13.857808, -5.901574) ",
    points: "11.7984969 -0.257113949 15.9026852 -0.252302474 15.9171197 12.0602627 11.8129313 12.0554512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3703321,56.2150459 L61.3703321,64.9166042 L34.6577992,64.9166042 L32.0294229,57.8024277 L34.6577992,49.1999526 L54.3387715,49.1999526 C58.2155135,49.1999526 61.3703321,52.3473829 61.3703321,56.2150459 L61.3703321,56.2150459 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.6577992,53.9832814 L34.6577992,69.6999329 L7.94526622,69.6999329 L7.94526622,60.9983746 C7.94526622,57.1307117 11.1000849,53.9832814 14.9768268,53.9832814 L34.6577992,53.9832814 Z",
    id: "Path",
    fill: "#FF4A4A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirenErrorIcon);
export default __webpack_public_path__ + "static/media/SirenErrorIcon.d3b3630df47b0d5faf7782cd7f527110.svg";
export { ForwardRef as ReactComponent };